<div class="flex flex-col sm:flex-row items-center md:items-start sm:justify-center md:justify-start flex-auto min-w-0">
    <div class="md:flex md:items-center md:justify-end w-full sm:w-auto md:h-full md:w-1/2 py-8 px-4 sm:p-12 md:p-16 sm:rounded-2xl md:rounded-none sm:shadow md:shadow-none sm:bg-card">
        <div class="w-full max-w-80 sm:w-80 mx-auto sm:mx-0">
            <!-- Logo -->
            <div class="w-50">
                <img src="assets/images/logo/logo.svg" alt="Skybox">
            </div>

            <!-- Title -->
            <div class="mt-8 text-4xl font-extrabold tracking-tight leading-tight">Registration</div>
            <div class="flex items-baseline mt-0.5 font-medium">
                <div>Sign up for a 90 day free trial.  Skybox Advanceds Administrator Console is fully functional for the first 90 days.  For pricing information,
                <a
                    class="ml-1 text-primary-500 hover:underline cursor-pointer"
                    (click)="getPricing()">click here.
                </a></div>
            </div>
            <div class="flex items-baseline mt-0.5 font-medium">
                <div style="margin-top:10px;">Already have an account?</div>
                <a
                    class="ml-1 text-primary-500 hover:underline"
                    [routerLink]="['/sign-in']">Sign In
                </a>
            </div>

            <!-- Alert -->
            <fuse-alert
                class="mt-8 -mb-4"
                *ngIf="showAlert"
                [appearance]="'outline'"
                [showIcon]="false"
                [type]="alert.type"
                [@shake]="alert.type === 'error'">
                {{alert.message}}
            </fuse-alert>

            <!-- Sign Up form -->
            <form
                class="mt-8"
                [formGroup]="signUpForm"
                #signUpNgForm="ngForm">

                <!-- Name field -->
                <mat-form-field class="w-full">
                    <mat-label>First Name</mat-label>
                    <input
                        id="firstName"
                        matInput
                        [formControlName]="'firstName'">
                    <mat-error *ngIf="signUpForm.get('firstName').hasError('required')">
                        First name is required
                    </mat-error>
                </mat-form-field>
                <!-- Name field -->
                <mat-form-field class="w-full">
                    <mat-label>Last Name</mat-label>
                    <input
                        id="lastName"
                        matInput
                        [formControlName]="'lastName'">
                    <mat-error *ngIf="signUpForm.get('lastName').hasError('required')">
                        Last name is required
                    </mat-error>
                </mat-form-field>

                <!-- Email field -->
                <mat-form-field class="w-full">
                    <mat-label>Email address</mat-label>
                    <input
                        id="email"
                        matInput
                        [formControlName]="'email'">
                    <mat-error *ngIf="signUpForm.get('email').hasError('required')">
                        Email address is required
                    </mat-error>
                    <mat-error *ngIf="signUpForm.get('email').hasError('email')">
                        Please enter a valid email address
                    </mat-error>
                </mat-form-field>

                <!-- Company field -->
                <mat-form-field class="w-full">
                    <mat-label>Company</mat-label>
                    <input
                        id="company-confirm"
                        matInput
                        [formControlName]="'company'">
                </mat-form-field>
                <div style="margin-top: 0;" class="terms" >
                    <mat-checkbox color="accent" name="terms" aria-label="I wish to receive email updates from Skybox Technologies"  formControlName="emailOptIn">
                        <span>I wish to receive email updates from</span><br>
                        <span>Skybox Technologies</span>
                    </mat-checkbox>
                </div>

                <div style="margin-bottom:20px" class="terms" >
                    <mat-checkbox color="accent" name="terms" aria-label="I read and accept"  formControlName="acknowledge">
                        <span>I read and accept</span>
                    </mat-checkbox>
                    <a
                        class="ml-1 text-primary-500 hover:underline"
                        (click)="openTermsDialog()" >terms and conditions
                    </a>
                </div>
                <div class="font-bold">CXone Information</div>
                <div class="flex-col items-baseline mt-0.5 font-medium">
                    <div>CXone User: {{registrationInformation.agentFirstName}} {{registrationInformation.agentLastName}}</div>
                    <div>Business Unit: {{registrationInformation.businessUnitName}} ({{registrationInformation.businessUnit}})</div>
                    <div>Business Unit Type: {{registrationInformation.businessUnitType}}</div>
                    <!--                <div>Domain: {{registrationInformation.businessUnitDomain}}</div>-->
                    <div>UserName: {{registrationInformation.username}}</div>
                    <div>
                        <a
                            class="ml-1 text-primary-500 hover:underline"
                            [routerLink]="['/sign-out']">Clear Login
                        </a>
                    </div>
                </div>





                <!-- Submit button -->
                <button
                    class="fuse-mat-button-large w-full mt-6"
                    mat-flat-button
                    [color]="'primary'"
                    [disabled]="signUpForm.invalid || signUpForm.disabled"
                    (click)="submitRegistration()">
                    <span *ngIf="!signUpForm.disabled">
                        Create your account
                    </span>
                    <mat-progress-spinner
                        *ngIf="signUpForm.disabled"
                        [diameter]="24"
                        [mode]="'indeterminate'"></mat-progress-spinner>
                </button>

            </form>
        </div>
    </div>
    <div class="relative hidden md:flex flex-auto items-center justify-center w-1/2 h-full p-16 lg:px-24 overflow-hidden bg-gray-800 dark:border-l">
        <!-- Background - @formatter:off -->
        <!-- Rings -->
        <svg class="absolute inset-0 pointer-events-none"
             viewBox="0 0 960 540" width="100%" height="100%" preserveAspectRatio="xMidYMax slice" xmlns="http://www.w3.org/2000/svg">
            <g class="text-gray-700 opacity-25" fill="none" stroke="currentColor" stroke-width="100">
                <circle r="234" cx="196" cy="23"></circle>
                <circle r="234" cx="790" cy="491"></circle>
            </g>
        </svg>
        <!-- Dots -->
        <svg class="absolute -top-16 -right-16 text-gray-700"
             viewBox="0 0 220 192" width="220" height="192" fill="none">
            <defs>
                <pattern id="837c3e70-6c3a-44e6-8854-cc48c737b659" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                    <rect x="0" y="0" width="4" height="4" fill="currentColor"></rect>
                </pattern>
            </defs>
            <rect width="220" height="192" fill="url(#837c3e70-6c3a-44e6-8854-cc48c737b659)"></rect>
        </svg>
        <!-- @formatter:on -->
        <!-- Content -->
        <div class="z-10 relative w-full max-w-2xl">
            <div class="text-6xl font-bold leading-none text-gray-100">
                <div>Advanced Admin Console</div>
            </div>
            <div class="mt-6 text-lg tracking-tight leading-6 text-gray-400">
                The Skybox Advanced Administrator Console allows CXone admins to quickly make changes to the configuration of the CXone platform.  Start saving hours of your day using the tool that the leading implementation partner uses.
            </div>
            <div class="flex items-center mt-8">
                <div class="flex flex-0 items-center -space-x-1.5">
                    <img
                        class="flex-0 w-10 h-10 rounded-full ring-4 ring-offset-1 ring-gray-800 ring-offset-gray-800 object-cover"
                        src="assets/images/avatars/female-18.jpg">
                    <img
                        class="flex-0 w-10 h-10 rounded-full ring-4 ring-offset-1 ring-gray-800 ring-offset-gray-800 object-cover"
                        src="assets/images/avatars/female-11.jpg">
                    <img
                        class="flex-0 w-10 h-10 rounded-full ring-4 ring-offset-1 ring-gray-800 ring-offset-gray-800 object-cover"
                        src="assets/images/avatars/male-09.jpg">
                    <img
                        class="flex-0 w-10 h-10 rounded-full ring-4 ring-offset-1 ring-gray-800 ring-offset-gray-800 object-cover"
                        src="assets/images/avatars/male-16.jpg">
                </div>
                <div class="ml-4 font-medium tracking-tight text-gray-400">...over 800 customers implemented on the CXone Platform</div>
            </div>
        </div>
    </div>
</div>
